<template>
  <ConfirmationModal
    :title="$t('CONFIRM_PRICING')"
    :entity="pricingPlan"
    :show-confirm-button="true"
    :show-cancel-button="true"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('CONFIRM')"
    :confirm-button-disabled="!confirmValue"
    @close="closeModal"
    @confirm="confirmPricing"
  >
    <div class="m-b-15">
      <span class="m-r-10">{{ $t('INSTANT_CALLER_PROFILE_COST') }}:</span>
      <Loader
        v-if="isLoadingData"
        custom-class="size-sm"
      />
      <strong v-else>
        {{ pricingPlan.dataEnrichmentCost | currency }} / {{ $t('REQUEST') }}
      </strong>
    </div>
    <p class="m-b-15" v-html="$t('INSTANT_CALLER_PROFILE_DESCRIPTION')" />
    <p class="m-b-15" v-html="$t('INSTANT_CALLER_PROFILE_TIP')" />
    <div class="form-horizontal">
      <div class="checkbox">
        <label class="display-flex flex-align--center">
          <input
            type="checkbox"
            v-model="confirmValue"
          />
          <span class="p-t-2" v-t="'INSTANT_CALLER_PROFILE_ATTEST'"></span>
        </label>
      </div>
    </div>

  </ConfirmationModal>
</template>

<script>
import { currencyFormatter } from '@/modules/reporting/components/AgGridUtils';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';

export default {
  name: 'ConfirmIcpPricingModal',
  components: {
    ConfirmationModal
  },
  filters: {
    currency(value) {
      return currencyFormatter.format(value);
    }
  },
  props:{
    pricingPlan: {
      type: Object,
      default() {
        return {};
      }
    },
    isLoadingData: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      confirmValue: false,
    };
  },
  methods:{
    closeModal() {
      this.$emit('onConfirmIcpPricing', false);
      this.$emit('closeModal');
    },
    confirmPricing() {
      this.$emit('onConfirmIcpPricing', true);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>